import React from "react";
import Footer from "../footer/Footer";
import VTUserTipHistory from "../page/VTUserTipHistory";
import Header from "../header/Header";

export default function LandingUserTipHistory() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserTipHistory/>
            <Footer/>
        </>
    );
}